import { ToastAlertTypes } from '@genial/components';

export const defaultErrorMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Erro ao carregar os detalhes da cesta.',
  'Ocorreu um erro ao carregar os detalhes da cesta,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];
